import React from 'react';
import CalltoActionSeven from '../../elements/calltoaction/CalltoActionSeven';
import CalltoActionEight from "../../elements/calltoaction/CalltoActionEight";
import CopyrightTwo from "./CopyrightTwo";
import ScrollTop from "./ScrollTop";


const Footer = () => {
    return (
        <>
            <div className="footer-style-2">
                <CalltoActionEight />
                <CalltoActionSeven />
                <CopyrightTwo />
            </div>
            <ScrollTop />
        </>
    )
}
export default Footer;